import {
    NEWS_ADMIN_FAILED,
    NEWS_ADMIN_FETCHING,
    NEWS_ADMIN_SUCCESS,
} from "../../Constants.ts";

export interface NewsAdminState {
    isFetching: boolean;
    isError: boolean;
    result: any;
}

const initialState: NewsAdminState = {
    isFetching: false,
    isError: false,
    result: null,
};

export default (state = initialState, { type, payload }: any): NewsAdminState => {
    switch (type) {
        case NEWS_ADMIN_FETCHING:
            return { ...state, isFetching: true, isError: false, result: null };
        case NEWS_ADMIN_SUCCESS:
            return { ...state, isFetching: false, isError: false, result: payload };
        case NEWS_ADMIN_FAILED:
            return { ...state, isFetching: false, isError: true, result: null };
        default:
            return state;
    }
};
